import React, { memo, useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useDisclosure } from "@chakra-ui/react"

import { useCore } from "@app/hooks/useCore"
import { ProductSizingTable } from "./ProductSizingTable"
import { ProductSizingToggle } from "./ProductSizingToggle"

import type { ProductCombinedProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
}

export const ProductSizing: React.FC<Props> = memo(({ product }) => {
  const { sizing } = useStaticQuery<GatsbyTypes.ProductSizingQuery>(graphql`
    query ProductSizing {
      sizing: allSanitySettingSizing {
        edges {
          node {
            image: _rawImage(resolveReferences: { maxDepth: 2 })
            instructions: _rawInstructions(resolveReferences: { maxDepth: 2 })
            table: sizing {
              rows {
                key: _key
                cells
              }
            }
            tags
          }
        }
      }
    }
  `)
  const {
    helpers: { edgeNormaliser },
  } = useCore()
  const { isOpen, onToggle } = useDisclosure()

  const guide = useMemo(
    () =>
      (edgeNormaliser(sizing) as Array<GatsbyTypes.SanitySettingSizing>)?.find(
        ({ tags }) => !!tags?.length && product?.tags?.some(productTag => tags.some(t => t?.toLowerCase() === productTag.toLowerCase()))
      ),
    [edgeNormaliser, product, sizing]
  )

  return guide ? (
    <>
      <ProductSizingToggle handleToggle={onToggle} />
      <ProductSizingTable isOpen={isOpen} handleToggle={onToggle} sizing={guide} />
    </>
  ) : null
})
